import type { TranslationKey } from './en.js';

export const ru: Partial<Record<TranslationKey, string>> = {
  'app.name': 'Volt',

  'section.chat': 'Чат',
  'section.image': 'Изображения',
  'section.video': 'Видео',
  'section.video2': 'Видео 2 (Marketing Studio)',
  'section.character': 'Персонаж',
  'section.audio': 'Музыка и аудио',
  'section.voice': 'Голос',
  'section.design': 'Дизайн',

  'common.loading': 'Загрузка…',
  'common.error': 'Что-то пошло не так',
  'common.retry': 'Повторить',
  'common.refresh': 'Обновить',
  'common.cancel': 'Отмена',
  'common.confirm': 'Подтвердить',
  'common.save': 'Сохранить',
  'common.close': 'Закрыть',
  'common.delete': 'Удалить',
  'common.create': 'Создать',
  'common.apply': 'Применить',
  'common.offline': 'Офлайн — показаны сохранённые данные',
  'common.you': 'Вы',
  'common.assistant': 'Ассистент',
  'common.empty': 'Здесь пока пусто',
  'common.back': 'Назад',

  'auth.loading': 'Выполняется вход…',
  'auth.openInTelegram': 'Откройте меня в Telegram',
  'auth.openInTelegramHint':
    'Volt работает как Telegram Mini App. Запустите его из чата с ботом, чтобы войти.',
  'auth.retry': 'Повторить',
  'auth.error': 'Не удалось войти',
  'auth.devHint': 'Режим разработки — без данных Telegram.',

  'topbar.menu': 'Открыть меню',
  'topbar.settings': 'Настройки',
  'topbar.balance': 'Баланс',

  'directChat.open': 'Открыть личный чат',
  'pager.chat': 'Чат',
  'pager.label': 'Переключение страниц',
  'directChat.title': 'Личный чат',
  'directChat.yourId': 'Ваш ID: {id}',
  'directChat.addPlaceholder': 'Публичный ID или Telegram @username',
  'directChat.addFriend': 'Добавить друга',
  'directChat.addSelf': 'Нельзя добавить самого себя в друзья.',
  'directChat.friends': 'Друзья',
  'directChat.noFriends':
    'Пока нет друзей. Добавьте пользователя по публичному ID или Telegram @username.',
  'directChat.selectFriend': 'Выберите друга, чтобы открыть переписку.',
  'directChat.noMessages': 'Сообщений пока нет. Напишите первым!',
  'directChat.messagePlaceholder': 'Напишите сообщение…',
  'directChat.send': 'Отправить сообщение',
  'directChat.notFound': 'Пользователь с таким ID или Telegram username не найден.',
  'directChat.noPermission': 'Можно писать только добавленному другу.',
  'directChat.addError': 'Проверьте ID или username: возможно, пользователь уже добавлен.',
  'directChat.error': 'Не удалось загрузить чат. Попробуйте ещё раз.',
  'directChat.openDrawer': 'Открыть список чатов',
  'directChat.chats': 'Чаты',
  'directChat.groups': 'Группы',
  'directChat.newGroup': 'Новая группа',
  'directChat.createGroup': 'Создать группу',
  'directChat.groupName': 'Название группы',
  'directChat.selectMembers': 'Выберите участников ({count}/50 с вами)',
  'directChat.memberCount': 'Участников: {count}',
  'directChat.messages': 'Сообщения',
  'directChat.messageActions': 'Действия с сообщением',
  'directChat.edit': 'Редактировать сообщение',
  'directChat.editing': 'Редактирование сообщения',
  'directChat.saveEdit': 'Сохранить изменения',
  'directChat.share': 'Поделиться сообщениями',
  'directChat.selectMessage': 'Выбрать сообщение',
  'directChat.selectedCount': 'Выбрано: {count}',
  'directChat.aiConfigurationError':
    'Нет доступной поддерживаемой нейросети. Выберите другую модель или попросите администратора настроить провайдера.',
  'directChat.reply': 'Ответить',
  'directChat.replyingTo': 'Ответ для {name}',
  'directChat.forward': 'Переслать',
  'directChat.forwarded': 'Переслано',
  'directChat.chooseDestination': 'Выберите чат для пересылки',
  'directChat.deleteForMe': 'Удалить у себя',
  'directChat.deleteForEveryone': 'Удалить у всех',
  'directChat.deleteForEveryoneConfirm': 'Удалить это сообщение для всех участников чата?',
  'directChat.aiAttribution': 'Искусственный интеллект',
  'directChat.aiToggleEnabled': 'Ответы нейросети включены',
  'directChat.aiToggleDisabled': 'Ответы нейросети выключены',
  'directChat.aiGenerating': 'Нейросеть отвечает…',
  'directChat.aiGenerationError': 'Не удалось получить ответ нейросети: {error}',
  'directChat.aiChooseModel': 'Выбрать нейросеть',
  'directChat.aiLongPressHint': 'Удерживайте для выбора нейросети',
  'directChat.sent': 'Отправлено',
  'directChat.delivered': 'Доставлено',
  'directChat.read': 'Прочитано',
  'directChat.loadOlder': 'Загрузить ранние сообщения',
  'directChat.mute': 'Без звука',
  'directChat.unmute': 'Включить звук',
  'directChat.muted': 'Без звука',
  'directChat.draft': 'Черновик:',
  'directChat.unreadDivider': 'Непрочитанные сообщения',
  'directChat.typing': 'печатает…',
  'directChat.online': 'в сети',
  'directChat.voiceRecord': 'Записать голосовое',
  'directChat.voiceStop': 'Остановить запись',
  'directChat.voiceUnavailable': 'Микрофон недоступен',
  'directChat.pinnedMessage': 'Закреплённое сообщение',
  'directChat.pinMessage': 'Закрепить сообщение',
  'directChat.unpinMessage': 'Открепить сообщение',
  'directChat.delete': 'Удалить',
  'directChat.pushEnable': 'Включить уведомления',
  'directChat.pushDisable': 'Выключить уведомления',
  'directChat.pushDenied': 'Уведомления заблокированы в браузере',
  'directChat.removeAttachment': 'Убрать вложение',
  'directChat.searchPlaceholder': 'Поиск по сообщениям',
  'directChat.searchResults': 'Результаты поиска',
  'directChat.noResults': 'Ничего не найдено',
  'directChat.addMenu': 'Новый чат или группа',
  'directChat.newChat': 'Новый чат',
  'directChat.backToChats': 'Назад к чатам',
  'directChat.noChats': 'Чатов пока нет. Нажмите +, чтобы начать.',
  'directChat.noArchived': 'Архив пуст',
  'directChat.chatActions': 'Действия с чатом',
  'directChat.pin': 'Закрепить',
  'directChat.unpin': 'Открепить',
  'directChat.archive': 'В архив',
  'directChat.unarchive': 'Из архива',
  'directChat.rename': 'Переименовать',
  'directChat.renameTitle': 'Переименовать контакт',
  'directChat.renamePlaceholder': 'Имя (пусто — сбросить)',
  'directChat.block': 'Заблокировать',
  'directChat.unblock': 'Разблокировать',
  'directChat.deleteChat': 'Удалить чат',
  'directChat.deleteForBoth': 'Удалить у обоих',
  'directChat.leaveGroup': 'Выйти из группы',
  'directChat.archivedChats': 'Архив ({count})',
  'directChat.blockedBanner': 'Вы заблокировали этого пользователя.',
  'directChat.blockedBadge': 'Заблокирован',
  'directChat.unread': 'Непрочитанных: {count}',

  'sidebar.title': 'Чаты',
  'sidebar.newChat': 'Новый чат',
  'sidebar.search': 'Поиск',
  'sidebar.searchPlaceholder': 'Поиск по чатам…',
  'sidebar.projects': 'Проекты',
  'sidebar.newProject': 'Новый проект',
  'sidebar.noConversations': 'Диалогов пока нет',
  'sidebar.archived': 'Архив',
  'sidebar.showArchived': 'Показать архив',
  'sidebar.hideArchived': 'Скрыть архив',
  'sidebar.pinned': 'Закреплённые',
  'sidebar.dropToPin': 'Отпустите, чтобы закрепить',
  'sidebar.dropToUnpin': 'Отпустите, чтобы открепить',
  'sidebar.today': 'Сегодня',
  'sidebar.yesterday': 'Вчера',
  'sidebar.previous7Days': 'Предыдущие 7 дней',
  'sidebar.previous30Days': 'Предыдущие 30 дней',
  'sidebar.older': 'Ранее',
  'sidebar.newFolder': 'Новая папка',
  'sidebar.deleteFolderTitle': 'Удалить папку?',
  'sidebar.deleteFolderConfirm': 'Чаты из неё останутся в списке, удалится только папка.',
  'sidebar.folderName': 'Название папки…',
  'sidebar.removeFromFolder': 'Убрать из папки',
  'sidebar.folders': 'Папки',
  'sidebar.history': 'История чатов',
  'sidebar.allChats': 'Все чаты',

  'menu.rename': 'Переименовать',
  'menu.pin': 'Закрепить',
  'menu.unpin': 'Открепить',
  'menu.archive': 'В архив',
  'menu.unarchive': 'Из архива',
  'menu.addToFolder': 'Добавить в папку',
  'menu.moveUp': 'Выше',
  'menu.moveDown': 'Ниже',
  'menu.delete': 'Удалить',
  'menu.deleteTitle': 'Удалить чат?',
  'menu.deleteConfirm': 'Диалог и все сообщения будут удалены безвозвратно.',

  'project.name': 'Название проекта',
  'project.description': 'Описание',
  'project.systemPrompt': 'Инструкции',
  'project.systemPromptHint': 'Эти инструкции отправляются модели для каждого чата в проекте.',
  'project.create': 'Создать проект',
  'project.empty': 'Проектов пока нет',

  'composer.placeholder': 'Сообщение для Volt…',
  'composer.imagePlaceholder': 'Опишите нужное изображение…',
  'composer.videoPlaceholder': 'Опишите нужное видео…',
  'composer.characterPlaceholder': 'Опишите персонажа…',
  'composer.audioPlaceholder': 'Опишите музыку или аудио…',
  'composer.voicePlaceholder': 'Текст для озвучивания…',

  'character.tabSoulId': 'Soul ID',
  'character.tabCharacter': 'Character',
  'character.tabSoulCast': 'Soul Cast',
  'character.tabAiInfluencer': 'AI Influencer',
  'character.soulIdTitle': 'Обучение Soul ID',
  'character.characterTitle': 'Персонажи',
  'character.soulCastTitle': 'Soul Cast',
  'character.aiInfluencerTitle': 'AI Influencer',
  'character.name': 'Имя',
  'character.description': 'Описание',
  'character.bio': 'Био',
  'character.style': 'Стиль',
  'character.scene': 'Сцена',
  'character.prompt': 'Промпт',
  'character.referenceImages': 'Ссылки на референсы, по одной в строке',
  'character.pickSoulId': 'Выберите Soul ID',
  'character.pickCharacter': 'Выберите персонажа',
  'character.noSoulLinked': 'Без привязанного Soul ID',
  'character.scopeLabel': 'Что создаём',
  'character.scopeHead': 'Голова',
  'character.scopeFullBody': 'Во весь рост',
  'character.scopeHeadHint': 'Лучше всего подходят крупные планы лица с разных ракурсов.',
  'character.scopeFullBodyHint': 'Добавьте фото в полный рост, чтобы получился весь персонаж.',
  'character.scopeBadgeHead': 'Голова',
  'character.scopeBadgeFullBody': 'Во весь рост',
  'character.model3dCreate': 'Создать 3D-модель',
  'character.model3dView': 'Смотреть в 3D',
  'character.model3dBuilding': 'Собираем 3D-модель… это занимает несколько минут.',
  'character.model3dFailed': 'Не удалось создать 3D-модель',
  'character.model3dRetry': 'Повторить',
  'character.model3dStarted': '3D-модель создаётся',
  'character.model3dStage': 'Окно просмотра 3D-модели',
  'character.model3dLoading': 'Загружаем модель…',
  'character.model3dError': 'Не удалось открыть 3D-модель.',
  'character.model3dUnsupported': 'Устройство не поддерживает 3D (WebGL).',
  'character.model3dHint': 'Потяните, чтобы вращать · щипок или колесо — приблизить',
  'character.model3dReset': 'Сбросить вид',
  'character.model3dAutoRotate': 'Автовращение',
  'character.soulIdPhotoHint': 'Загрузите 5–20 референсных фото.',
  'character.soulIdPhotoCount': 'Нужно выбрать от 5 до 20 фото.',
  'character.soulIdUploadFailed': 'Не удалось загрузить фото. Попробуйте ещё раз.',
  'character.createSoulId': 'Создать Soul ID',
  'character.createCharacter': 'Создать персонажа',
  'character.createAiInfluencer': 'Создать AI Influencer',
  'character.generateSoulCast': 'Сгенерировать Soul Cast',
  'character.generateContent': 'Сгенерировать контент',
  'character.status.training': 'Обучается',
  'character.status.ready': 'Готов',
  'character.status.failed': 'Ошибка',
  'character.soulIdPhotoTips':
    'Лучший результат: 10–20 резких фото одного человека — лицо анфас, оба ракурса три четверти и профиль, с улыбкой и без, разное освещение, без очков и других людей.',
  'character.voiceSample': 'Образец голоса (необязательно)',
  'character.voiceSampleHint':
    'Загрузите 30–120 с чистой речи (mp3, wav, m4a), чтобы клонировать голос — говорящие видео будут звучать как этот человек.',
  'character.voiceSamplePick': 'Выбрать запись',
  'character.identityPack': 'Пакет идентичности',
  'character.identityPackHint':
    'Чистые эталонные кадры, отрисованные по фото; каждая генерация использует их, чтобы лицо не плыло.',
  'character.identityPackMissing': 'Пакета идентичности нет: генерации используют фото напрямую.',
  'character.likeness': 'Схожесть {score}/100',
  'character.voiceReady': 'Голос клонирован',
  'character.voiceFailed': 'Голос не клонирован',
  'character.castMode': 'Что создаём',
  'character.castModeImage': 'Картинка в сцене',
  'character.castModeVideo': 'Видео в сцене',
  'character.castModeTalking': 'Говорящий персонаж (липсинк)',
  'character.castModePerformance': 'Перенести мою игру (мимика + движения)',
  'character.castTier': 'Качество',
  'character.castTierBudget': 'Цена-качество',
  'character.castTierMax': 'Максимальный реализм',
  'character.castTierTalkingHint': 'Цена-качество: Kling AI Avatar v2 (~$0.06/с). Максимум: OmniHuman 1.5 (~$0.16/с) — эмоции, жесты, язык тела.',
  'character.castTierPerformanceHint': 'Цена-качество: Wan Animate (~$0.08/с). Максимум: Kling 3.0 Motion Control (~$0.17/с) — самый точный перенос мимики.',
  'character.castText': 'Что говорит персонаж',
  'character.castTextHint': 'Озвучивается клонированным голосом, если он есть у Soul ID, иначе студийным. До 60 с.',
  'character.castAudio': 'или загрузите запись (mp3, wav, m4a)',
  'character.castDrivingVideo': 'Видео с вашей игрой (mp4/mov, до 30 с, 8 МБ)',
  'character.castDrivingVideoHint': 'Снимите себя анфас при хорошем свете: мимика, движения головы и тела перенесутся на персонажа.',
  'character.castActingPrompt': 'Заметки по игре (необязательно)',
  'character.castNeedsSoul': 'Для говорящих и актёрских видео нужен обученный Soul ID.',
  'character.castNeedsText': 'Введите текст или загрузите запись.',
  'character.castNeedsVideo': 'Загрузите видео для переноса.',
  'character.castStarted': 'Генерация запущена',
  'character.castTooLong': 'Файл длиннее {max} с',
  'character.pickFile': 'Выбрать файл',
  'character.removeFile': 'Убрать',
  'character.quality': 'Качество',
  'character.qualityStandard': 'Стандарт (пакет идентичности)',
  'character.qualityMax': 'Максимум (+ дообучение LoRA, ~$3, 5–10 мин)',
  'character.qualityHint':
    'Стандарт рисует чистые эталонные кадры с вами. Максимум дополнительно обучает личную модель на ваших фото: самое точное лицо на картинках.',
  'character.consentSelfie': 'Живое селфи (согласие)',
  'character.consentSelfieHint':
    'Сделайте селфи камерой прямо сейчас. Мы проверим, что на фото именно вы; Soul ID других людей создавать нельзя.',
  'character.consentSelfieTake': 'Сделать селфи',
  'character.consentVerified': 'Личность подтверждена',
  'character.consentFailed': 'Селфи не совпало',
  'character.loraTraining': 'Обучаем личную модель…',
  'character.loraReady': 'Личная модель готова',
  'character.loraFailed': 'Личная модель не обучилась',
  'character.checkPhotos': 'Проверить мои фото',
  'character.checkingPhotos': 'Проверяем…',
  'character.photoCheckOk': 'Набор выглядит хорошо.',
  'character.photoCheckMissing': 'Не хватает: {items}',
  'character.photoCheckProblems': 'Проблемы: {items}',
  'character.recordVoice': 'Записать образец голоса',
  'character.recordVoiceStop': 'Остановить запись',
  'character.recordVoiceScript':
    'Прочитайте вслух в обычном темпе (60–90 с), близко к микрофону, в тихой комнате:',
  'character.recordVoiceScriptText':
    'Привет! Сегодня хочу рассказать о том, что для меня важно. Каждое утро начинается одинаково: кофе, короткая прогулка и план на день. Иногда что-то идёт не так, и это нормально, главное продолжать двигаться. Задам вопрос: что бы вы сделали с одним лишним часом в сутках? Запишите, подумайте и сделайте это завтра. Спасибо, что дослушали, до встречи!',
  'character.recordVoiceFailed': 'Нет доступа к микрофону',
  'character.templates': 'Шаблоны',
  'character.templateReel': 'Вертикальный рилс',
  'character.templateFollowers': 'Обращение к подписчикам',
  'character.templateProduct': 'Обзор продукта',
  'character.templateGreeting': 'Поздравление',
  'character.templateReelPrompt':
    'Вертикальный ролик 9:16 в стиле лайфстайл, съёмка с телефона с рук, улица города в золотой час, иду к камере и улыбаюсь',
  'character.templateFollowersText':
    'Всем привет! Спасибо, что вы здесь. На этой неделе у меня большие новости, так что следите за обновлениями и не пропустите следующий пост!',
  'character.templateProductText':
    'Сегодня тестирую кое-что новое. Первые впечатления: лёгкий, работает из коробки и сэкономил мне время. Расскажу, как пользуюсь им каждый день.',
  'character.templateGreetingText':
    'С днём рождения! Желаю здоровья, радости и ярких дней. Пусть этот год принесёт именно то, о чём вы мечтали!',
  'character.enhancePrompt': 'Улучшать промпт автоматически (кинематографичная переработка)',
  'character.upscale': 'Улучшить ролик до 1080p после генерации',
  'character.estimate': 'Ориентировочно: ≈ {rub} ₽',
  'character.estimateParts': 'в {parts} частях',
  'character.estimating': 'Считаем стоимость…',
  'character.castDuration': 'Длина ролика',
  'character.part': 'Часть {index} из {count}',
  'character.castModeUpscale': 'Версия 1080p',
  'character.rateUp': 'Похоже на меня',
  'character.rateDown': 'Не похоже',
  'composer.send': 'Отправить',
  'composer.stop': 'Остановить',
  'composer.attach': 'Прикрепить файлы',
  'composer.attachTitle': 'Добавить вложение',
  'composer.attachAllPhotos': 'Все фото',
  'composer.attachCamera': 'Камера',
  'composer.attachPhotos': 'Фотографии',
  'library.fromLibrary': 'Из моих генераций',
  'library.title': 'Мои генерации',
  'library.empty': 'Вы пока ничего не сгенерировали',
  'library.loading': 'Загрузка…',
  'library.loadMore': 'Показать ещё',
  'library.attach': 'Прикрепить ({count}/{max})',
  'library.loadFailed': 'Не удалось загрузить файл. Попробуйте ещё раз.',
  'composer.attachFiles': 'Файлы',
  'composer.attachFilesHint': 'Фото без сжатия',
  'composer.attachmentTooLarge': 'Файл слишком большой (не больше {max} МБ).',
  'composer.tooManyAttachments': 'Не больше {max} вложений в одном сообщении.',
  'composer.attachToFolder': 'Добавить в папку',
  'composer.voiceMode': 'Голосовой режим',
  'quiz.submit': 'Продолжить',
  'quiz.sent': 'Ответы отправлены',
  'quiz.preparing': 'Готовлю вопросы…',
  'quiz.multipleHint': 'можно несколько',
  'quiz.answersIntro': 'Мои ответы:',
  'voice.title': 'Голосовой диалог',
  'voice.status.starting': 'Подключаю микрофон…',
  'voice.status.listening': 'Слушаю…',
  'voice.status.transcribing': 'Распознаю…',
  'voice.status.thinking': 'Думаю…',
  'voice.status.speaking': 'Говорю…',
  'voice.status.error': 'Голосовой диалог остановлен',
  'voice.hint': 'Просто говорите. Я отвечу, когда вы сделаете паузу.',
  'voice.tapToInterrupt': 'Нажмите на круг, чтобы перебить',
  'voice.interrupt': 'Перебить и говорить',
  'voice.end': 'Завершить разговор',
  'voice.micDenied': 'Разрешите доступ к микрофону, чтобы говорить.',
  'voice.micUnavailable': 'Микрофон здесь недоступен.',
  'voice.ttsFallback': 'Ответы озвучивает голос вашего устройства.',
  'voice.settings': 'Настройки голоса',
  'voice.holdToTalk': 'Удерживайте, чтобы говорить',
  'voice.releaseToSend': 'Отпустите, чтобы отправить',
  'voice.set.voice': 'Голос',
  'voice.set.speed': 'Скорость речи',
  'voice.set.tone': 'Тон',
  'voice.tone.neutral': 'Нейтральный',
  'voice.tone.warm': 'Тёплый',
  'voice.tone.cheerful': 'Бодрый',
  'voice.tone.calm': 'Спокойный',
  'voice.set.model': 'Модель для разговора',
  'voice.model.fast': 'Быстрая',
  'voice.model.chat': 'Как в чате',
  'voice.set.recognition': 'Распознавание речи',
  'voice.recognition.standard': 'Обычное',
  'voice.recognition.high': 'Улучшенное',
  'voice.set.talkMode': 'Разговор',
  'voice.talk.auto': 'Без рук',
  'voice.talk.push': 'Зажать и говорить',
  'voice.set.reaction': 'Реакция на паузы',
  'voice.reaction.quick': 'Быстрая',
  'voice.reaction.normal': 'Обычная',
  'voice.reaction.calm': 'Терпеливая',
  'voice.set.bargeIn': 'Перебивать голосом',
  'voice.set.bargeInHint': 'Заговорите поверх ассистента, чтобы остановить его. Лучше в наушниках.',
  'voice.set.cues': 'Звук, пока ассистент думает',
  'voice.set.webSearch': 'Доступ в интернет',
  'composer.voiceInput': 'Голосовой ввод',
  'composer.dialogUnsupported': 'Голосовой ввод не поддерживается в этом браузере',
  'composer.listening': 'Слушаю…',
  'composer.thinking': 'Думаю…',
  'composer.model': 'Модель',
  'composer.selectModel': 'Выбрать модель',
  'composer.unavailable': 'Недоступно',
  'composer.estimate': '≈ {price}',
  'composer.topUpHint': 'Пополните баланс до {amount}, чтобы продолжить',
  'composer.generate': 'Сгенерировать',
  'composer.webSearch': 'Доступ в интернет',
  'composer.webSearchOn': 'Интернет включён',
  'composer.autoMode': 'Авто-режим',
  'composer.autoModeUsing': 'Использует {model}',
  'composer.manageModels': 'Управление моделями',
  'composer.searchModels': 'Поиск моделей…',
  'composer.providerAll': 'Все провайдеры',
  'composer.providerClaude': 'Claude',
  'composer.providerGrok': 'Grok',
  'composer.providerGemini': 'Gemini',
  'composer.providerGPT': 'GPT',
  'composer.providerKimi': 'Kimi',
  'composer.providerDeepSeek': 'DeepSeek',
  'composer.providerMicrosoft': 'Microsoft AI',
  'composer.internetOnly': 'Только с доступом в интернет',
  'composer.internetAll': 'Все',
  'composer.internetWith': 'С интернетом',
  'composer.internetWithout': 'Без интернета',
  'composer.quickList': 'Быстрый список',
  'composer.addToQuickList': 'Добавить в быстрый список',
  'composer.removeFromQuickList': 'Убрать из быстрого списка',
  'composer.modelInfo': 'Подробности модели',
  'composer.modelInfoOpen': 'Подробности модели: {model}',
  'composer.modelInfoProvider': 'Провайдер',
  'composer.modelInfoSection': 'Раздел',
  'composer.modelInfoModality': 'Режим',
  'composer.modelInfoContextLimit': 'Лимит контекста',
  'composer.modelInfoMaxOutput': 'Макс. выходных токенов',
  'composer.modelInfoPricingUnit': 'Единица тарификации',
  'composer.modelInfoWebSearch': 'Доступ в интернет',
  'composer.modelInfoStreaming': 'Стриминг',
  'composer.modelInfoVision': 'Vision',
  'composer.modelInfoYes': 'Да',
  'composer.modelInfoNo': 'Нет',
  'composer.noModelsForFilters': 'Нет моделей под текущие фильтры',
  'composer.resetFilters': 'Сбросить фильтры',
  'composer.difficultyAll': 'Любые задачи',
  'composer.difficulty.fast': 'Быстрые ответы',
  'composer.difficulty.normal': 'Обычные задачи',
  'composer.difficulty.complex': 'Сложные задачи',
  'composer.difficulty.expert': 'Экспертные задачи',
  'composer.modelsCount': 'Моделей: {count}',
  'composer.clearSearch': 'Очистить поиск',

  'message.attachContext': 'Прикрепить сообщение как контекст',
  'message.pinChapter': 'Закрепить как главу',
  'message.unpinChapter': 'Открепить главу',
  'chapters.title': 'Главы',
  'message.rewind': 'Вернуться сюда',
  'message.rewindTitle': 'Вернуться к этому сообщению?',
  'message.rewindConfirm': 'Это сообщение и всё, что следует за ним, будет удалено без возможности восстановления.',
  'message.retry': 'Повторить',
  'message.notSent': 'Не отправлено. Повторим, когда появится связь.',
  'suggest.explain': 'Объясни: ',
  'suggest.write': 'Напиши: ',
  'suggest.translate': 'Переведи: ',
  'suggest.summarize': 'Кратко перескажи: ',
  'suggest.ideas': 'Придумай идеи для: ',
  'chat.scrollDown': 'Вниз к последним',
  'chat.offline': 'Нет соединения. История доступна офлайн.',
  'admin.subscriptionPlans': 'Тарифы подписок',
  'admin.placeholder.markup': 'напр. 30',
  'admin.placeholder.usd': 'напр. 90',
  'admin.placeholder.min': 'напр. 5',
  'settings.showTransactions': 'Показать',
  'shareSheet.title': 'Поделиться ответом',
  'shareSheet.hint': 'Любой, у кого есть ссылка, сможет просмотреть этот диалог.',
  'shareSheet.messages': 'Сообщения',
  'shareSheet.more': 'Ещё',
  'shareSheet.toChats': 'В чат Volt или выбрать сообщения…',
  'chat.pullNewChat': 'Новый чат',
  'chat.newTitle': 'Новый чат',
  'message.copy': 'Копировать',
  'message.copied': 'Скопировано',
  'message.share': 'Поделиться',
  'message.regenerate': 'Повторить',
  'message.edit': 'Изменить',
  'message.save': 'Сохранить и отправить',
  'message.editError':
    'Не удалось сохранить изменения. Исходное сообщение не изменено; попробуйте ещё раз.',
  'message.up': 'Хороший ответ',
  'message.down': 'Плохой ответ',
  'message.usage': '{model} · {input} вход · {output} выход · {cost}',
  'message.usageNoModel': '{input} вход · {output} выход · {cost}',
  'message.failed': 'Ошибка генерации',
  'message.reasoningTitle': 'Ход обработки',
  'conversation.pinnedBadge': 'Закреплённый чат',

  'share.button': 'Поделиться',
  'share.createLink': 'Создать ссылку',
  'share.copyLink': 'Копировать ссылку',
  'share.copied': 'Скопировано!',
  'share.revoke': 'Отозвать ссылку',
  'share.revokeConfirm':
    'Вы уверены, что хотите отозвать эту ссылку? Доступ по ссылке будет закрыт для всех.',
  'share.title': 'Поделиться диалогом',
  'share.conversation': 'Поделиться диалогом',
  'share.selectMessages': 'Выбрать несколько сообщений',
  'share.selectedCount': 'Выбрано: {count}',
  'share.forwardSelected': 'Переслать выбранные сообщения',
  'share.exitSelection': 'Отменить выбор',
  'share.sharedBy': 'Публичный снимок',
  'share.notFound': 'Ссылка истекла или была отозвана.',
  'share.openApp': 'Открыть Volt',
  'share.loading': 'Загрузка…',
  'share.sendToChat': 'Отправить в чат',
  'share.noDestinations': 'Нет доступных чатов или бесед',
  'share.mediaTitle': 'Поделиться фото или видео',
  'job.share': 'Поделиться',
  'share.sentSuccess': 'Отправлено!',
  'share.sending': 'Отправка…',
  'share.loadingDestinations': 'Загрузка чатов…',
  'artifact.preview': 'Просмотр',
  'artifact.code': 'Код',
  'artifact.open': 'Открыть артефакт',
  'artifact.export': 'Экспорт',
  'artifact.download': 'Скачать',
  'artifact.copy': 'Копировать',
  'artifact.edit': 'Редактировать',
  'artifact.close': 'Закрыть',
  'artifact.fullscreen': 'На весь экран',

  'job.status': 'Статус',
  'job.pending': 'В очереди',
  'job.processing': 'Обработка…',
  'job.done': 'Готово',
  'job.failed': 'Ошибка',
  'job.cancelled': 'Отменено',
  'job.result': 'Результат',
  'video2.prompt': 'Промпт для Marketing Studio',
  'video2.productSource': 'Источник продукта',
  'video2.productFromUrl': 'Click-to-Ad (URL)',
  'video2.productFromImages': 'Создать продукт из изображений',
  'video2.productExisting': 'Использовать существующие product ID',
  'video2.productUrl': 'URL продукта',
  'video2.productIds': 'Product ID (через запятую или с новой строки)',
  'video2.productTitle': 'Название продукта',
  'video2.avatarType': 'Аватар',
  'video2.avatarNone': 'Без аватара',
  'video2.avatarPreset': 'Preset-аватар',
  'video2.avatarCustom': 'Custom avatar ID',
  'video2.customAvatarIds': 'Custom avatar ID (через запятую или с новой строки)',
  'video2.adApproach': 'Подход к рекламе',
  'video2.adApproachReference': 'По референсу (ad reference)',
  'video2.adApproachBlocks': 'Блоки Hook/Setting',
  'video2.adReferenceId': 'ID ad reference',
  'video2.hookId': 'ID hook',
  'video2.settingId': 'ID setting',
  'video2.mode': 'Режим',
  'video2.adFormat': 'Формат рекламы',
  'video2.formatId': 'Format ID',
  'video2.duration': 'Длительность (сек)',
  'video2.resolution': 'Разрешение',
  'video2.aspectRatio': 'Соотношение сторон',
  'video2.generateAudio': 'Генерировать аудио',
  'video2.errorProductRequired':
    'Укажите URL продукта, существующий product ID или изображения с названием продукта.',
  'video2.errorAdApproachRequired':
    'Укажите ID ad reference или заполните хотя бы один из Hook/Setting.',
  'video2.errorFormatRequired': 'Для dtc-ads нужно указать Format ID.',
  'video2.errorProductImagesLimit': 'До {max} фото товара, каждое не больше {size}.',

  'job.empty': 'Генераций пока нет',
  'job.actions': 'Действия',
  'job.favoriteAdd': 'Добавить в избранное',
  'job.favoriteRemove': 'Убрать из избранного',
  'job.favorited': 'Избранное',
  'job.regenerate': 'Перегенерировать',
  'job.viewPrompt': 'Посмотреть промт',
  'job.promptTitle': 'Промт',
  'job.download': 'Скачать',
  'job.deleteTitle': 'Удалить генерацию?',
  'job.deleteConfirm': 'Эта генерация будет удалена без возможности восстановления.',
  'job.cancel': 'Отменить генерацию',
  'job.uploading': 'Загружаем файлы…',
  'job.uploadFailed': 'Не удалось загрузить файлы. Попробуйте ещё раз.',

  'video.modeLabel': 'Режим видео',
  'video.modeCreate': 'Создание',
  'video.modeEdit': 'Редактирование',
  'video.modeExtend': 'Продолжение',
  'video.modeMotionControl': 'Motion Control',
  'video.fieldGeneric': 'Это поле',
  'video.fieldImages': 'Изображения',
  'video.fieldReferenceImages': 'Референс-изображения',
  'video.fieldFirstFrameImage': 'Изображение первого кадра',
  'video.fieldLastFrameImage': 'Изображение последнего кадра',
  'video.fieldMainVideo': 'Основное видео',
  'video.fieldClips': 'Клипы / видео',
  'video.fieldAudio': 'Аудио',
  'video.fieldInputVideo': 'Исходное видео',
  'video.fieldLibraryVideo': 'Видео из App Library',
  'video.fieldMotionVideo': 'Видео-референс движения',
  'video.fieldCharacterImages': 'Изображения персонажа',
  'video.ratio': 'Соотношение сторон',
  'video.ratioAutoHelper': 'Авто подстраивает соотношение сторон под исходные данные.',
  'video.duration': 'Длительность',
  'video.durationInput': 'Равна длительности загруженного видео',
  'video.durationInputValue': 'Равна длительности загруженного видео: {value}',
  'video.resolution': 'Разрешение',
  'video.audioGeneration': 'Генерация аудио',
  'video.audioLanguages': 'Поддерживаемые языки: {languages}',
  'video.audioLanguagesMulti': 'несколько языков',
  'video.audioLanguagesUnavailable': 'Поддерживаемые языки для этой модели не указаны.',
  'video.audioSourceMode': 'Исходное аудио',
  'video.audioSourcePreserve': 'Сохранить исходное аудио',
  'video.audioSourceChange': 'Изменить исходное аудио',
  'video.orientation': 'Ориентация',
  'video.orientationAuto': 'Авто',
  'video.orientationVideo': 'Видео',
  'video.orientationImage': 'Изображение',
  'video.contentMode': 'Режим контента',
  'video.contentModeGrokFirstFrame': 'Изображение первого кадра',
  'video.contentModeGrokImages': 'До 7 изображений',
  'video.contentModeVeoImages': 'До 3 изображений',
  'video.contentModeVeoFrames': 'Первый / последний кадр',
  'video.contentModeMinimaxMultimodal': 'Мультимодальные референсы',
  'video.contentModeMinimaxFrames': 'Первый / последний кадр',
  'video.contentModeSeedanceMultimodal': 'Мультимодальные референсы',
  'video.contentModeSeedanceFrames': 'Первый / последний кадр',
  'video.contentModeGeminiReferences': 'Референсы',
  'video.contentModeGeminiFrames': 'Первый / последний кадр',
  'video.contentModeWanMultimodal': 'Мультимодальные референсы',
  'video.contentModeWanFrames': 'Первый / последний кадр',
  'video.contentModeWanReference': 'Референс в видео',
  'video.contentModeWanImageEdit': 'Редактирование изображения',
  'video.contentModeWanVideoEdit': 'Редактирование видео / референс-видео',
  'video.contentModeWanAudioInput': 'Аудиовход',
  'video.contentModeWanFirstFrame': 'Изображение первого кадра',
  'video.promptLimit': 'Лимит промпта: {max} символов',
  'video.modeModelListEmpty': 'В этом режиме сейчас нет доступных моделей.',
  'video.modeModelListMissing': 'Режим временно недоступен. Отсутствуют ожидаемые модели: {ids}',
  'video.libraryVideoPlaceholder': 'Выберите VEO-видео из App Library',
  'video.libraryVideoLoading': 'Проверяем metadata видео из App Library…',
  'video.libraryVideoHelper':
    'Для продолжения подходят только готовые VEO-видео из App Library длительностью до 140 секунд.',
  'video.libraryVideoEmpty': 'Подходящих VEO-видео в App Library пока нет.',
  'video.libraryVideoName': 'Выбранный asset',
  'video.libraryVideoDuration': 'Длительность',
  'video.libraryVideoOrigin': 'Происхождение',
  'video.libraryVideoOriginUnknown': 'Неизвестное происхождение',
  'video.libraryVideoPreviewLabel': 'Превью {name}',
  'video.clearFiles': 'Очистить файлы',
  'video.howToUse': 'Как использовать',
  'video.helperRequired': 'Обязательно.',
  'video.helperOptional': 'Необязательно.',
  'video.helperExactFiles': '{count} файл(ов).',
  'video.helperFileRange': '{min}-{max} файл(ов).',
  'video.helperMinFiles': 'Минимум {min} файл(ов).',
  'video.helperFormats': 'Форматы: {formats}.',
  'video.helperMaxEach': 'Максимум {max} на файл.',
  'video.helperDuration': 'Длительность: {min}-{max} сек.',
  'video.helperTotalDuration': 'Суммарная длительность ≤ {max} сек.',
  'video.helperMaxResolution': 'До {value}.',
  'video.validationRequired': 'Поле «{field}» обязательно',
  'video.validationPromptMax': 'Prompt превышает лимит {max} символов для этой модели',
  'video.validationCount': 'Поле «{field}»: максимум {max} файлов',
  'video.validationFormat': 'Поле «{field}»: файл «{name}» с форматом {mime} не поддерживается',
  'video.validationSize': 'Поле «{field}»: файл «{name}» превышает лимит {max}',
  'video.validationDuration': 'Поле «{field}»: файл «{name}» должен быть от {min} до {max} секунд',
  'video.validationTotalDuration':
    'Поле «{field}»: суммарная длительность не должна превышать {max} секунд',
  'video.validationTotalCount': 'Общее количество загруженных файлов не должно превышать {max}',
  'video.validationUnsupported': 'Поле «{field}» не поддерживается этой моделью',
  'video.validationLibraryVideoReference':
    'У выбранного видео из App Library отсутствует стабильная ссылка на asset или job.',
  'video.validationLibraryVideoOriginMissing':
    'У выбранного видео из App Library отсутствуют metadata о модели-источнике.',
  // prettier-ignore
  'video.validationLibraryVideoOriginInvalid': 'Продолжать можно только видео, исходно созданные поддерживаемыми моделями Google VEO.',
  'video.validationLibraryVideoDurationMissing':
    'У выбранного видео из App Library отсутствуют metadata о длительности.',
  'video.validationLibraryVideoMaxDuration':
    'Выбранное видео из App Library должно быть не длиннее {max} секунд.',

  'image.modelInfo': 'Информация о модели',
  'image.maxInputImages': 'Макс. вх. изображений',
  'image.inputFormats': 'Входные форматы',
  'image.imageSizeMax': 'Макс. размер изображения',
  'image.modalities': 'Режимы',
  'image.nativeOutput': 'Разрешения',
  'image.flexibleRatio': 'Соотношение',
  'image.outputCount': 'Количество',
  'image.decreaseCount': 'Уменьшить количество',
  'image.increaseCount': 'Увеличить количество',
  'image.outputFormat': 'Формат',
  'image.background': 'Фон',
  'image.backgroundOpaque': 'Непрозрачный',
  'image.backgroundTransparent': 'Прозрачный',
  'image.quality': 'Качество',
  'image.attachImages': 'Прикрепить изображения',
  'image.attachedImages': 'Прикреплено {count} изображение(й)',
  'image.textOnly': 'Только текст',
  'image.validationCount': 'Слишком много файлов: максимум {max} для этой модели',
  'image.validationFormat': '«{name}»: формат {mime} не поддерживается этой моделью',
  'image.validationSize': '«{name}»: файл превышает лимит {max} для этой модели',

  'design.subtitle': 'Откройте инструмент дизайна в новом окне',
  'design.open': 'Открыть',

  'settings.title': 'Настройки',
  'settings.profile': 'Профиль',
  'settings.appearance': 'Оформление',
  'settings.theme': 'Тема',
  'settings.themeLight': 'Светлая',
  'settings.themeDark': 'Тёмная',
  'settings.themeSystem': 'Системная',
  'settings.language': 'Язык',
  'settings.balance': 'Баланс',
  'settings.topup': 'Пополнить',
  'settings.topupAmount': 'Сумма, ₽',
  'settings.topupSubmit': 'Пополнить баланс',
  'settings.transactions': 'История операций',
  'settings.noTransactions': 'Операций пока нет',
  'settings.loadMore': 'Показать ещё',
  'settings.notifications': 'Уведомления',
  'settings.notificationsHint': 'Уведомлять о завершении генераций',
  'settings.data': 'Ваши данные',
  'settings.exportData': 'Экспорт моих данных',
  'settings.deleteAccount': 'Удалить аккаунт',
  'settings.deleteAccountTitle': 'Удалить аккаунт?',
  'settings.deleteAccountConfirm':
    'Аккаунт, диалоги и баланс будут удалены безвозвратно. Отменить нельзя.',
  'settings.username': 'Имя пользователя',
  'settings.name': 'Имя',
  'settings.personalization': 'Персонализация',
  'settings.customInstructions': 'Пользовательские инструкции',
  'settings.customInstructionsHint': 'Добавляются в системный промпт каждого чата',
  'settings.responseStyle': 'Стиль ответа',
  'settings.responseStyleDefault': 'По умолчанию',
  'settings.responseStyleFormal': 'Формальный',
  'settings.responseStyleTeacher': 'Преподаватель',
  'settings.responseStyleConcise': 'Краткий',
  'settings.rules': 'Правила',
  'settings.rulesHint': 'Правила, которым должен следовать ассистент',
  'settings.addRule': 'Добавить правило',
  'settings.ruleInputPlaceholder': 'Новое правило…',
  'settings.personalizationSaved': 'Персонализация сохранена',

  'admin.title': 'Админ',
  'admin.stats': 'Статистика',
  'admin.users': 'Пользователи',
  'admin.settings': 'Настройки платформы',
  'admin.markup': 'Наценка, %',
  'admin.usdRub': 'Курс USD → RUB',
  'admin.minBalance': 'Мин. баланс, ₽',
  'admin.contextLimit': 'Сообщений в контексте',
  'admin.models': 'Цены моделей',
  'admin.price': 'Цена',
  'admin.revenue': 'Выручка',
  'admin.cost': 'Расходы провайдеров',
  'admin.margin': 'Маржа',
  'admin.activeUsers': 'Активные (24ч)',
  'admin.failedJobs': 'Ошибок задач',
  'admin.ban': 'Заблокировать',
  'admin.unban': 'Разблокировать',
  'admin.adjustBalance': 'Изменить баланс',
  'admin.reason': 'Причина',
  'admin.amount': 'Сумма, ₽',
  'admin.debugConsole': 'Консоль отладки',
  'admin.errorHistory': 'История ошибок',
  'admin.tabModels': 'Нейросети',
  'admin.tabOperations': 'Операции',
  'admin.tabAnalytics': 'Аналитика',
  'admin.tabErrors': 'Ошибки',
  'admin.modelMonitoring': 'Мониторинг AI-моделей',
  'admin.modelEventsSectionTitle': 'Журнал событий',
  'admin.modelStatesSectionTitle': 'Состояние моделей',
  'admin.modelEventsEmpty': 'Событий по моделям пока нет.',
  'admin.modelCheck': 'Проверить',
  'admin.modelDisable': 'Отключить',
  'admin.modelActivate': 'Активировать',
  'admin.modelMonitoringLoadFailed': 'Не удалось загрузить мониторинг моделей.',
  'admin.syncNow': 'Синхронизировать',
  'admin.analyticsLoadFailed': 'Не удалось загрузить аналитику.',
  'admin.errorHistoryLoadFailed': 'Не удалось загрузить историю ошибок.',
  'admin.errorsEmpty': 'Ошибок пока нет.',

  'error.UNAUTHORIZED': 'Сессия истекла. Откройте приложение заново.',
  'error.FORBIDDEN': 'Нет доступа.',
  'error.USER_BANNED': 'Ваш аккаунт заблокирован.',
  'error.NOT_FOUND': 'Не найдено.',
  'error.RATE_LIMITED': 'Слишком много запросов. Помедленнее.',
  'error.DAILY_LIMIT_EXCEEDED': 'Дневной лимит исчерпан. Попробуйте завтра.',
  'error.INSUFFICIENT_BALANCE': 'Недостаточно средств для запроса.',
  'error.BELOW_MIN_BALANCE': 'Баланс ниже минимального.',
  'error.MODEL_UNAVAILABLE': 'Модель сейчас недоступна.',
  'error.MODEL_NOT_SUPPORTED': 'Модель здесь не поддерживается.',
  'error.PROVIDER_ERROR': 'Провайдер вернул ошибку.',
  'error.PROVIDER_TIMEOUT': 'Провайдер не ответил вовремя.',
  'error.VALIDATION_ERROR': 'Запрос не принят. Проверьте данные и попробуйте ещё раз.',
  'error.PAYLOAD_TOO_LARGE': 'Файл слишком большой.',
  'admin.blockedTopics': 'Заблокированные темы',
  'admin.blockedTopicsHint': 'Сообщения с этими словами или фразами отклоняются для всех пользователей. Основа слова блокирует все формы: «казино» заблокирует и «казино-онлайн».',
  'admin.blockedTopicsPlaceholder': 'Слово или фраза',
  'admin.blockedTopicsAdd': 'Добавить',
  'error.TOPIC_BLOCKED': 'Эта тема заблокирована администратором.',
  'error.CONTEXT_TOO_LARGE': 'Диалог слишком длинный для модели.',
  'error.PAYMENT_INVALID': 'Не удалось обработать платёж.',
  'error.INTERNAL': 'Ошибка сервера. Попробуйте ещё раз.',
  'error.network': 'Ошибка сети. Проверьте подключение.',
  'error.streamInterrupted': 'Соединение прервалось. Ответ восстановлен с сервера.',
  'error.generic': 'Что-то пошло не так.',
};
